export default {
  SET_GROUP(state, groups) {
    state.groups = groups
  },

  SET_GROUP_SELECT(state, groups) {
    state.groupsSelect = groups
  }
}